/**
 * 用于控制异步并发执行
 */
export default class SuperTask<T> {
  private parallelCount: number;

  private runningCount: number;

  private tasks: {
    task: () => Promise<T>;
    resolve: (value?: T | PromiseLike<T>) => void;
    reject: (error: any) => void;
  }[];

  private allTasksCompletedResolver: (() => void) | undefined;

  private allTasksCompletedPromise: Promise<void>;

  constructor(parallelCount = 1) {
    // 默认只能同时执行一个异步
    this.parallelCount = parallelCount;
    this.runningCount = 0;
    this.tasks = [];
    this.allTasksCompletedResolver = undefined;
    this.allTasksCompletedPromise = new Promise<void>((resolve) => {
      this.allTasksCompletedResolver = resolve;
    });
  }

  // 添加task并执行
  add(task: () => Promise<T>): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      // 收集resolve和reject是为了可以拿到每一个task的执行结果，可在add时链式接收
      this.tasks.push({
        task,
        resolve: resolve as (value?: T | PromiseLike<T>) => void,
        reject,
      });
      this.run();
    });
  }

  // 依次运行tasks队列里的所有任务
  private run(): void {
    while (this.runningCount < this.parallelCount && this.tasks.length > 0) {
      const nextTask = this.tasks.shift();
      if (nextTask) {
        const { task, resolve, reject } = nextTask;
        this.runningCount += 1;
        task()
          .then(resolve)
          .catch(reject)
          .finally(() => {
            this.runningCount -= 1;
            this.run();
            if (
              this.tasks.length === 0 &&
              this.runningCount === 0 &&
              this.allTasksCompletedResolver
            ) {
              // 最后一个执行完毕则resolve->waitForAllTasks
              this.allTasksCompletedResolver();
            }
          });
      }
    }
  }

  // 全部task执行完毕（无论成功失败）后执行waitForAllTasks的resolve
  waitForAllTasks(): Promise<void> {
    return this.allTasksCompletedPromise;
  }
}
